import React from "react";

const listView: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g fill="currentcolor" transform="translate(.132 .085)">
                    <path d="M0 15.938C0 15.42.336 15 .75 15h15c.414 0 .75.42.75.938 0 .517-.336.937-.75.937h-15c-.414 0-.75-.42-.75-.938zm0-7.5C0 7.92.336 7.5.75 7.5h15c.414 0 .75.42.75.938 0 .517-.336.937-.75.937h-15c-.414 0-.75-.42-.75-.938zm0-7.5C0 .42.336 0 .75 0h15c.414 0 .75.42.75.938 0 .517-.336.937-.75.937h-15c-.414 0-.75-.42-.75-.938z"></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(listView);
